import React from "react";
import PropTypes from "prop-types";
import { Box, Card, CardContent, CircularProgress, Typography } from "@material-ui/core";
import { makeStyles, createStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) =>
  createStyles({
    card: {
      borderRadius: 8,
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
      overflow: "hidden",
      boxShadow: "0 1px 2px rgba(15, 23, 42, 0.04)",
      border: "1px solid #e5e7eb",
    },
    content: {
      padding: theme.spacing(2),
      "&:last-child": {
        paddingBottom: theme.spacing(2),
      },
    },
    header: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      gap: theme.spacing(1),
      marginBottom: theme.spacing(1),
    },
    title: {
      fontSize: 14,
      fontWeight: 700,
      color: "#1f2937",
    },
    subtitle: {
      fontSize: 12,
      color: "#6b7280",
      whiteSpace: "nowrap",
    },
    list: {
      display: "grid",
      gap: 11,
      marginTop: theme.spacing(1),
    },
    row: {
      display: "grid",
      gridTemplateColumns: "minmax(200px, 240px) minmax(0, 1fr) 28px",
      alignItems: "center",
      gap: 8,
      fontSize: 12,
      color: "#334155",
    },
    name: {
      whiteSpace: "nowrap",
      overflow: "visible",
      fontWeight: 500,
      letterSpacing: 0.1,
    },
    track: {
      height: 14,
      borderRadius: 999,
      background: "#eff6ff",
      overflow: "hidden",
    },
    fill: {
      height: "100%",
      background: "linear-gradient(90deg, #60a5fa, #2563eb)",
    },
    value: {
      textAlign: "right",
      fontWeight: 700,
      color: "#1e293b",
    },
    loadingWrap: {
      minHeight: 180,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
  })
);

const formatNumber = (value) => new Intl.NumberFormat("ja-JP").format(value);

const PlotUserRankingPreview = ({ rows, title, subtitle, loading }) => {
  const classes = useStyles();
  const max = rows.length > 0 ? rows[0].value : 1;

  return (
    <Card className={classes.card}>
      <CardContent className={classes.content}>
        <div className={classes.header}>
          <Typography className={classes.title}>{title}</Typography>
          <Typography className={classes.subtitle}>{subtitle}</Typography>
        </div>
        {loading ? (
          <Box className={classes.loadingWrap}>
            <CircularProgress size={28} />
          </Box>
        ) : (
          <div className={classes.list}>
            {rows.map((row) => (
              <div key={row.name} className={classes.row}>
                <div className={classes.name}>{row.name}</div>
                <div className={classes.track}>
                  <div className={classes.fill} style={{ width: `${(row.value / max) * 100}%` }} />
                </div>
                <div className={classes.value}>{formatNumber(row.value)}</div>
              </div>
            ))}
          </div>
        )}
      </CardContent>
    </Card>
  );
};

PlotUserRankingPreview.propTypes = {
  rows: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      value: PropTypes.number.isRequired,
    })
  ).isRequired,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  loading: PropTypes.bool,
};

PlotUserRankingPreview.defaultProps = {
  title: "ユーザー別プロット数（上位10名）",
  subtitle: "プレビュー",
  loading: false,
};

export default PlotUserRankingPreview;
